var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { Emit } from "vue-property-decorator";
import DataForm from "~/components/common/data-form.vue";
import { CaseRepaymentService } from "~/services/domain-service/case-repayment.service";
var TeamCaseRepayment = /** @class */ (function (_super) {
    __extends(TeamCaseRepayment, _super);
    function TeamCaseRepayment() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = {
            state: false
        };
        _this.model = {
            caseNumber: "",
            personalName: "",
            overdueAmount: "",
            repaymentAmount: "",
            id: ""
        };
        _this.rules = {
            repaymentAmount: [{ required: true, message: "请输入还款金额" }, { pattern: /^(?!(0[0-9]{0,}$))[0-9]{1,}[.]{0,}[0-9]{0,}$/, message: '还款金额必须是大于0的数' }]
        };
        return _this;
    }
    /**
     * 重置form表单
     */
    TeamCaseRepayment.prototype.resetForm = function () {
        var repaymentForm = this.$refs["form"];
        repaymentForm.resetFields();
        this.model.repaymentAmount = "";
    };
    TeamCaseRepayment.prototype.close = function () {
        this.resetForm();
    };
    /**
     * 反显数据
     */
    TeamCaseRepayment.prototype.update = function (data) {
        if (!data.id)
            return;
        this.model.caseNumber = data.caseNumber;
        this.model.personalName = data.personalName;
        this.model.overdueAmount = data.overdueAmount;
        this.model.id = data.id;
    };
    TeamCaseRepayment.prototype.repaymantMax = function () {
        if (this.model.repaymentAmount > this.model.overdueAmount) {
            this.model.repaymentAmount = this.model.overdueAmount;
        }
        // if(this.model.repaymentAmount < 0){
        //   this.model.repaymentAmount=0
        // }
    };
    /**
     * 确定按钮
     */
    TeamCaseRepayment.prototype.ConfirmBtn = function () {
        var _this = this;
        var form = this.$refs['form'];
        form.validate(function (v) {
            if (!v)
                return;
            _this.caseRepaymentService.addCaseRepayment(_this.model).subscribe(function (data) {
                _this.$message.success("还款成功");
                _this.close();
            });
        });
    };
    __decorate([
        Dependencies(CaseRepaymentService)
    ], TeamCaseRepayment.prototype, "caseRepaymentService", void 0);
    __decorate([
        Emit("close")
    ], TeamCaseRepayment.prototype, "close", null);
    TeamCaseRepayment = __decorate([
        Component({
            components: {
                DataForm: DataForm
            }
        })
    ], TeamCaseRepayment);
    return TeamCaseRepayment;
}(Vue));
export default TeamCaseRepayment;
